import axios from 'axios';
import Util from '../Util'

class TimelineAPI {

    constructor() {
        this.apiHost = process.env.VUE_APP_API_HOST;
    }

    listEntries(baseIndex){

        let path = "/reports/timeline";
        if (baseIndex){
            path += "/" + baseIndex
        }

        let endpoint =  Util.combineUrl(this.apiHost , Util.buildApiPath(path));

        return axios.get(endpoint).then(response => {
            const data = Util.addSnakeCaseAliasesDeep(Util.toCamelCaseDeep(response.data));
            return data.data;
        })
    }


    listMyEntries(baseIndex){

        let path = "/home";
        if (baseIndex){
            path += "/" + baseIndex
        }

        let endpoint =  Util.combineUrl(this.apiHost , Util.buildApiPath(path));

        return axios.get(endpoint).then(response => {
            const data = Util.addSnakeCaseAliasesDeep(Util.toCamelCaseDeep(response.data));
            return data.data;
        })
    }

    // タイムラインのカーソル（スナップショット）が期限切れかを判定する（SPEC-034）
    // サーバは 410 / TIMELINE_EXPIRED を返すので、呼び出し側は先頭から取得し直す
    isTimelineExpired(err){
        const res = err && err.response;
        const code = res && res.data && res.data.error && res.data.error.code;
        return code === "TIMELINE_EXPIRED";
    }

    putAlreadyRead(reportId){

        let path = "/reports/" + reportId + "/read";

        let endpoint =  Util.combineUrl(this.apiHost, Util.buildApiPath(path));

        return axios.put(endpoint, {}).then(response => Util.addSnakeCaseAliasesDeep(Util.toCamelCaseDeep(response.data)))
    }

    deleteAlreadyRead(reportId){

        let path = "/reports/" + reportId + "/read";

        let endpoint =  Util.combineUrl(this.apiHost, Util.buildApiPath(path));

        return axios.delete(endpoint, {}).then(response => Util.addSnakeCaseAliasesDeep(Util.toCamelCaseDeep(response.data)))
    }

}

let _api = new TimelineAPI();

export default _api;
